import React, {FC} from "react";
import BasketItem from "modules/booking/types/BasketItem";
import NcImage from "modules/ui/shared/NcImage/NcImage";
import {StarIcon} from "@heroicons/react/24/solid";
import Prebooking from "../../modules/booking/types/Prebooking";
import useTranslate from "../../modules/core/languages/hooks/useTranslate";
import useCustomerContext from "../../modules/customers/hooks/useCustomerContext";
import moment from "moment";
import {formatNumber} from "../../modules/common/utils/number";
import CheckoutPriceSummary from "../PageCheckout/CheckoutPriceSummary";

interface SidebarProps {
    basketItems: BasketItem[] | undefined;
    prebooking: Prebooking | undefined;
}

const Sidebar: FC<SidebarProps> = ({ basketItems = [], prebooking }) => {
    const t = useTranslate();
    const {languageCode} = useCustomerContext();

    const renderItem = (item: BasketItem) => {
        return (
            <div key={item.id}>
                <div className="flex flex-col sm:flex-row sm:items-center">
                    <div className="flex-shrink-0 w-full sm:w-40">
                        <div className=" aspect-w-4 aspect-h-3 sm:aspect-h-4 rounded-2xl overflow-hidden">
                            <NcImage src={item.hotelObject.imgContentUrl} />
                        </div>
                    </div>
                    <div className="py-5 sm:px-5 space-y-3">
                        <div>
                            <span className="text-base font-medium mt-1 block">
                                <div className="flex items-end">
                                    {[...Array(item.hotelObject.stars)].map((value, index) => <StarIcon className="w-[18px] h-[18px] text-orange-500" key={index} />)}
                                </div>
                                {item.hotelObject.name}
                            </span>
                        </div>
                        <span className="block  text-sm text-neutral-500 dark:text-neutral-400">
                            {item.trName[languageCode]}
                        </span>
                        <span className="block  text-sm text-neutral-500 dark:text-neutral-400">
                            {t("checkout.from")}: {moment(item.arrivalDate).format('DD/MM/YYYY')}
                        </span>
                        <span className="block  text-sm text-neutral-500 dark:text-neutral-400">
                            {t("checkout.to")}: {moment(item.departureDate).format('DD/MM/YYYY')}
                        </span>
                        <div className="w-10 border-b border-neutral-200  dark:border-neutral-700"></div>
                    </div>
                </div>

                <div className="flex flex-col space-y-4">
                    <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                        <span>{t("checkout.total_nights")}</span>
                        <span>{item.totalNights} {t("checkout.nights")}</span>
                    </div>
                    <div className="border-b border-neutral-200 dark:border-neutral-700"></div>

                    <div className="flex justify-between">
                        <div className="flex flex-row">
                            <span>{t("checkout.total")}</span>
                        </div>
                        <div>{formatNumber(item.priceWithTaxes)} <span dangerouslySetInnerHTML={{ __html:item.currencySymbol}} /></div>
                    </div>
                </div>
            </div>
        )
    };

    return (
            <div className="w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8">

            {basketItems ? basketItems.map((item) => renderItem(item))
                : null }

            <div className="border-b border-neutral-200 dark:border-neutral-700"></div>

            {prebooking && basketItems && basketItems.length > 0 && (
                <CheckoutPriceSummary
                    totalWithTaxes={prebooking.totalWithTaxes}
                    totalWithoutTaxes={prebooking.totalWithoutTaxes}
                    taxes={prebooking.taxes}
                    taxRate={basketItems[0].taxRate}
                    discount={prebooking.discount}
                    discountAmount={prebooking.discountAmount}
                    discountPercent={prebooking.discountPercent}
                    totalBasket={prebooking.totalBasket}
                    currencySymbol={basketItems[0].currencySymbol}
                />
            )}
        </div>
    )
}

export default Sidebar;
